var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.614,
    height: 17.504,
    viewBox: "0 0 13.614 17.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.472,20.059A1.951,1.951,0,0,0,10.417,22H18.2a1.951,1.951,0,0,0,1.945-1.945V8.39H8.472ZM21.114,5.472h-3.4L16.738,4.5H11.876l-.972.972H7.5V7.417H21.114Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4cfc5e8b4da42abddd355371c3d7e688.svg";
export { ForwardRef as ReactComponent };